import styled from "styled-components"

export default function InquiryBtn() {
  return (
    <Block>
      <Button href="http://pf.kakao.com/_gmtJs/chat" target="_blank">
        문의하기
      </Button>
    </Block>
  )
}

const Block = styled.div`
  padding: 0 calc(100vw * (17 / 375));
`

const Button = styled.a`
  width: 100%;
  text-align: center;
  background-color: #f7f7f7;
  border-radius: calc(100vw * (5 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (14 / 375));
  padding: calc(100vw * (15 / 375)) 0;
  cursor: pointer;
`
